import React from 'react';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import FibersProductLobbyPageData from 'Models/Content/FibersProductLobbyPageData';

export default class FibersProductLobbyPage extends Page<FibersProductLobbyPageData> {
  render() {
    const {
      data: {mainContentArea},
      context,
    } = this.props;

    return (
      <div className='FibersProductLobbyPage'>
        <ContentArea data={mainContentArea} context={context} noWrap />
      </div>
    );
  }
}
